import { helper } from '@ember/component/helper';

/**
 * Verifica se param1 è maggiore (o maggiore/uguale) di param2
 * @param {boolean} inclusive - Se true, verifica >= invece di >
 */
var isGt = helper(function isGt([param1, param2, inclusive = false]) {
  if (param1 == null || param2 == null) return false;
  const val1 = Number(param1);
  const val2 = Number(param2);
  if (isNaN(val1) || isNaN(val2)) return false;
  return inclusive ? val1 >= val2 : val1 > val2;
});

export { isGt as default };
//# sourceMappingURL=is-gt.js.map
